import React, { FC } from "react";

import { ArrowLeftBig } from "@/assets/icons";

import ConversationChatInput, {
    ChatInputFormType,
    InputMode,
} from "./components/ConversationChatInput/ConversationChatInput";
import { ConversationMessageChatContainer } from "./styled";

type NewConversationMessageChatProps = {
    policyholderName: string;
    topic: string;
    objectTitle: string;
    policyholderId: number;
    onSubmitForm: (formData: ChatInputFormType) => Promise<boolean>;
    onBackPressed?: () => void;

    setTopic: React.Dispatch<React.SetStateAction<string>>;
    setMessage: React.Dispatch<React.SetStateAction<string>>;
};

const NewConversationMessageChat: FC<NewConversationMessageChatProps> = ({
    policyholderName,
    policyholderId,
    objectTitle,
    onSubmitForm,
    onBackPressed,
    topic,
    setTopic,
    setMessage,
}) => {
    return (
        <ConversationMessageChatContainer>
            <div className="chat-header">
                {onBackPressed && (
                    <div className="chat-header-action-icons">
                        <ArrowLeftBig onClick={onBackPressed} />
                    </div>
                )}
                <div className="chat-header-title-container">
                    <div className="chat-title">
                        {policyholderId} {policyholderName}
                    </div>
                    <div className="chat-subject-label">{objectTitle ?? topic}</div>
                </div>
            </div>
            <div className="conversation-chat-container">
                <div className="messages-container" />
            </div>
            <ConversationChatInput
                inputMode={
                    objectTitle != null ? InputMode.NewConversationWithContext : InputMode.NewConversationWithoutContext
                }
                onSubmitForm={onSubmitForm}
                disabled={false}
                setTopic={setTopic}
                setMessage={setMessage}
            />
        </ConversationMessageChatContainer>
    );
};

export default NewConversationMessageChat;
